import axios from 'axios';

let prefix = "/gacha"

const GachaApi = {
	listGacha(payload) {
		return axios.get(prefix + "/list", { params: payload })
	},
	getGachaInfo(payload) {
		return axios.get(prefix + "/get", { params: payload })
	},
	archiveGacha(payload) {
		return axios.delete(prefix + "/archive", { params: payload })
	},
	createGacha(payload) {
		return axios.post(prefix + "/create", payload)
	},
	updateGacha(payload) {
		return axios.post(prefix + "/update", payload)
	},
}

export default GachaApi;